


import React from 'react';
import Main from "./src/components/PageHeader/components/Main/Main";
import {initReactI18next} from "react-i18next";
import i18n from 'i18next';
import { translation_dic } from "./translations/translation-dic";
import { loadExtraTranslations } from "./translations/translation-dic";
import { HashRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import RouteLanguage from "./src/i18n/RouteLanguage";

i18n.use(initReactI18next).init({
    resources: translation_dic,
        lng: "en",                
    interpolation: {
        escapeValue: false,
        returnNull: false,
        returnEmptyString: false,
    },
    initImmediate: false,
    react: { useSuspense: false },
    fallbackLng: "en",
    });

function App() {
  const [ready, setReady] = React.useState(false);

  React.useEffect(() => {
    (async () => {

      const lng = localStorage.getItem('lang');
      if (lng && !i18n.hasResourceBundle(lng, 'translation')) {
        const extra = await loadExtraTranslations([lng]);
        if (extra?.translation) {
          i18n.addResourceBundle(lng, 'translation', extra.translation, true, true);
        }
      }
      setReady(true);
    })();
  }, []);

  if (!ready) return null;

    return (
    <HashRouter>
        <RouteLanguage />
        <ThemeProvider theme={theme}>
        <Main/>
        </ThemeProvider>
    </HashRouter>
    );
}



export default App;